// extracted by mini-css-extract-plugin
export default {"coverLink":"zJ-z","contentBox":"AJ-z","zapposPromoContainer":"BJ-z","zapposPromoGroupContainer":"CJ-z","promos":"DJ-z","bottom":"EJ-z","top":"FJ-z","right":"GJ-z","left":"HJ-z"};